export const serviceVars = {
    serm: 'serm_reports',
    ecom: 'ecom_reviews',
};

export const taskActionsVars = {
    create: 'create',
    list: 'list',
    view: 'view',
    add: 'add',
};
